import { Outlet, ScrollRestoration } from 'react-router'

import { ImageViewerProvider } from '@/components/common/image-viewer'
import { useCurrentUser } from '@/modules/accounts'
import { NotificationsMenu, useIncomingNotificationToasts } from '@/modules/notifications'

import { BottomNav } from './bottom-nav'
import { Brand } from './brand'
import { NavigationProgress } from './navigation-progress'
import { ContentBackdrop } from './shell-background'
import { Sidebar } from './sidebar'
import { usePageTitle } from './use-page-title'
import { useScrolled } from './use-scrolled'
import { UserMenu } from './user-menu'


export function AppLayout() {
  const pageTitle = usePageTitle()
  const scrolled = useScrolled()
  const { data: user } = useCurrentUser()
  useIncomingNotificationToasts(user?.id)

  return (
    <ImageViewerProvider>
    <div className="flex min-h-svh bg-background">
      <NavigationProgress />
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-50 focus:rounded-md focus:bg-background focus:px-3 focus:py-2 focus:shadow"
      >
        Skip to content
      </a>

      {/* Desktop rail */}
      <aside className="sticky top-0 hidden h-svh shrink-0 md:block">
        <Sidebar />
      </aside>

      <div className="relative isolate flex min-w-0 flex-1 flex-col">
        <ContentBackdrop />
        {/* Transparent over the dots at the top; frosted glass with a hairline once the page scrolls. */}
        <header
          data-scrolled={scrolled}
          className="sticky top-0 z-40 flex h-header items-center gap-2 px-4 transition-[background-color,box-shadow,backdrop-filter] duration-300 sm:px-6 lg:px-8 data-[scrolled=true]:bg-background/75 data-[scrolled=true]:shadow-[0_1px_0_var(--color-line)] data-[scrolled=true]:backdrop-blur-xl"
        >
          <div className="md:hidden">
            <Brand compact />
          </div>
          {pageTitle && <p className="truncate text-h4 md:text-h3">{pageTitle}</p>}

          <div className="ml-auto flex items-center gap-2 sm:gap-3">
            <NotificationsMenu />
            <div className="flex md:hidden">
              <UserMenu variant="header" />
            </div>
          </div>
        </header>

        <main id="main-content" tabIndex={-1} className="flex-1 overflow-x-clip outline-none">
          {/* Extra bottom padding on mobile keeps content clear of the floating bottom bar. */}
          <div className="w-full px-4 pt-2 pb-[calc(6rem+env(safe-area-inset-bottom))] sm:px-6 md:pb-8 lg:px-8">
            <Outlet />
          </div>
        </main>
      </div>

      <BottomNav />
      <ScrollRestoration />
    </div>
    </ImageViewerProvider>
  )
}
